/* dev-blog-slider.js — drag-to-scroll + arrow navigation */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('.blog-slider');
    sections.forEach(function (section) { init(section); });
  });

  function init(section) {
    var track = section.querySelector('[data-blog-slider-track]');
    var prevBtn = section.querySelector('[data-blog-slider-prev]');
    var nextBtn = section.querySelector('[data-blog-slider-next]');
    if (!track) return;

    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;

    /* --- Arrow visibility --- */

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;

      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    /* --- Arrow clicks: scroll by one card width --- */

    function getCardScrollAmount() {
      var card = track.querySelector('[data-blog-slide]');
      if (!card) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return card.offsetWidth + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getCardScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getCardScrollAmount(), behavior: 'smooth' });
      });
    }

    /* --- Mouse drag-to-scroll --- */

    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDragging = true;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var dx = e.clientX - startX;
      track.scrollLeft = scrollStart - dx;
    });

    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
    });

    // Prevent link clicks after drag
    track.addEventListener('click', function (e) {
      if (Math.abs(track.scrollLeft - scrollStart) > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }
})();
